import request from '@/config/axios'

// 文件模板 VO
export interface AiFileTemplateVO {
  id: number
  name: string
  fileUrl: string
  fileName?: string
  fileSize?: number
  remark?: string
  createTime?: Date
}

// 文件模板 API
export const FileTemplateApi = {
  // 分页
  getPage: async (params: any) => {
    return await request.get({ url: '/ai/file-template/page', params })
  },
  // 详情
  get: async (id: number) => {
    return await request.get({ url: '/ai/file-template/get?id=' + id })
  },
  // 新增
  create: async (data: AiFileTemplateVO) => {
    return await request.post({ url: '/ai/file-template/create', data })
  },
  // 更新
  update: async (data: AiFileTemplateVO) => {
    return await request.put({ url: '/ai/file-template/update', data })
  },
  // 删除
  delete: async (id: number) => {
    return await request.delete({ url: '/ai/file-template/delete?id=' + id })
  },
  // 下拉列表
  getSimpleList: async () => {
    return await request.get({ url: '/ai/file-template/simple-list' })
  },
  // 解析并预览 Word 模板中的 ${变量}
  getPlaceholders: async (id: number) => {
    return await request.get({ url: '/ai/file-template/placeholders?id=' + id })
  }
}
